module.exports = __webpack_public_path__ + "img/brand-gigastore-logo.ba0e08cc.svg";